import { render } from "./HouseDesignFilter.vue?vue&type=template&id=837edf36&scoped=true&ts=true&lang=pug"
import script from "./HouseDesignFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./HouseDesignFilter.vue?vue&type=script&setup=true&lang=ts"

import "./HouseDesignFilter.vue?vue&type=style&index=0&id=837edf36&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-837edf36"]])

export default __exports__